import {
  ControlsProps,
  FrameworkControls,
} from "~/pages/compliance/Framework/FrameworkOutlets";

const FrameworkControlsEntryPage = ({}: ControlsProps) => {
  return <FrameworkControls />;
};

export default FrameworkControlsEntryPage;
